<template>
  <div class="app-container">
    <div class="filter-container">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h4>算力池配置</h4>
        </div>
        <el-table border :data="packageConfigList">
          <el-table-column label="默认Token" align="center" prop="queueOneMaxToken">
            <template slot-scope="scope">
              <div>一号池：{{ scope.row.queueOneMaxToken }}</div>
              <div>二号池：{{ scope.row.queueTwoMaxToken }}</div>
              <div>A池：{{ scope.row.poolNumOneMaxCount }}</div>

            </template>
          </el-table-column>
          <el-table-column label="匹配数量" align="center" prop="queueOneRatio">
            <template slot-scope="scope">
              <div>一号池：{{ scope.row.queueOneRatio }}</div>
              <div>二号池：{{ scope.row.queueTwoRatio }}</div>
              <div>A池：{{ scope.row.poolNumOneMaxRatio * 100 }}%</div>
            </template>
          </el-table-column>
          <el-table-column label="增加虚人数区间" align="center">
            <template slot-scope="scope">
              <div>匹配中：{{ scope.row.unsuccessfulMinAddVirtual }} ~ {{ scope.row.unsuccessfulMaxAddVirtual }} 人</div>
              <div>匹配成功：{{ scope.row.successfulMinAddVirtual }} ~ {{ scope.row.successfulMaxAddVirtual }} 人</div>
            </template>
          </el-table-column>
          <el-table-column label="每日限购数量" align="center" prop="dailyOrderLimit">
          </el-table-column>
          <el-table-column label="最大次数" align="center" prop="maxPayCount">
            <template slot-scope="scope">
              <div>获取支付：{{ scope.row.maxPayCount }}</div>
              <div>获取价格：{{ scope.row.maxGetPriceCount }}</div>
              <div>奖励发放：{{ scope.row.maxRewardSendCount }}</div>
              <div>未成功奖励发放：{{ scope.row.maxRewardSendUnsuccessfulCount }}</div>
            </template>
          </el-table-column>
          <el-table-column label="获取支付次数金额区间" align="center" prop="minAddMoneyPayNotMax">
            <template slot-scope="scope">
              <div>未满：{{ scope.row.minAddMoneyPayNotMax }} ~ {{ scope.row.maxAddMoneyPayNotMax }}</div>
              <div>已满：{{ scope.row.minAddMoneyPayMax }} ~ {{ scope.row.maxAddMoneyPayMax }}</div>
            </template>
          </el-table-column>
          <el-table-column label="支付配置" align="center" prop="minAddMoneyPayNotMax">
            <template slot-scope="scope">
              <div>支付宝收款主体：{{ scope.row.aliPayConfig }}</div>
              <div>退款截止时间：{{ scope.row.endRefundTime }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <el-link type="primary" @click="packageConfigEditDialog = true">编辑</el-link>
          </el-table-column>
        </el-table>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-size: 16px;font-weight: bold;margin-right: 10px;">实时数据总览</span>
          <el-button type="primary" size="mini" @click="openTop10">合伙人账户收益排行榜</el-button>
        </div>
        <el-descriptions direction="vertical" :column="5" border>
          <el-descriptions-item label="收入" labelStyle="font-weight: bold;text-align: center"
                                contentStyle="text-align: center">
            <el-descriptions class="margin-top" :column="1" size="small" border>
              <el-descriptions-item label="总现金" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                {{
                  (poolStat.historyCashIncome || 0) | formatWan
                }}(扣除微信手续费: {{ (poolStat.historyCashIncome * 0.994).toFixed(2) | formatWan }})
              </el-descriptions-item>
              <el-descriptions-item label="总余额" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                {{ (poolStat.historyBalanceIncome || 0) | formatWan }}
              </el-descriptions-item>
              <el-descriptions-item label="供应链利润" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                {{
                  (((orderStatData.salesRevenue * 0.35) + orderStatData.cashRevenue - orderStatData.costRevenue) || 0) | formatWan
                }}
              </el-descriptions-item>
              <el-descriptions-item label="合伙人开通" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                <div>{{ (amountInfo.partnerIncome || 0) | formatWan }}
                  <el-link icon="el-icon-edit" size="mini" style="margin-left: 5px" type="primary"
                           @click="editComprehensiveAmount">编辑
                  </el-link>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="今日收入" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                <div>现金: {{
                    (poolStat.todayCashIncome || 0) | formatWan
                  }}({{ (poolStat.todayCashIncome * 0.994).toFixed(2) | formatWan }})
                </div>
                <div>余额: {{ (poolStat.todayBalanceIncome || 0) | formatWan }}</div>
              </el-descriptions-item>
              <el-descriptions-item label="昨日收入" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                <div>现金: {{
                    (poolStat.yesterdayCashIncome || 0) | formatWan
                  }}({{ (poolStat.yesterdayCashIncome * 0.994).toFixed(2) | formatWan }})
                </div>
                <div>余额: {{ (poolStat.yesterdayBalanceIncome || 0) | formatWan }}</div>
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>
          <el-descriptions-item label="支出" labelStyle="font-weight: bold;text-align: center"
                                contentStyle="text-align: center">
            <el-descriptions class="margin-top" :column="2" size="small" border>
              <el-descriptions-item label="提货券" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                <div>
                  可用: {{
                    amountInfo.activePickUpVoucher | formatWan
                  }}(实际成本: {{ (amountInfo.activePickUpVoucher * 0.35).toFixed(2) | formatWan }})
                </div>
                <div>
                  加速中: {{
                    (+poolInfo.oneLiquidationAmount || 0) + (+poolInfo.twoOverissuanceVoucherTotal || 0) + (+poolInfo.oneLiquidationVoucher || 0) + (+poolInfo.twoLiquidationVoucher || 0) | formatWan
                  }}
                </div>
                <div>
                  已兑付: {{
                    (orderStatData.salesRevenue || 0) | formatWan
                  }}(实际成本：{{ (orderStatData.costRevenue || 0) | formatWan }})
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="消费券" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                <div>待提：{{
                    amountInfo.activeVoucher | formatWan
                  }}(扣除手续费: {{ (amountInfo.activeVoucher * 0.94).toFixed(2) | formatWan }})
                </div>
                <div>已提：{{
                    amountInfo.withdrawVoucher | formatWan
                  }}(扣除手续费: {{ (amountInfo.withdrawVoucher * 0.94).toFixed(2) | formatWan }})
                </div>
                <div>待审：{{
                    amountInfo.withdrawWaitVoucher | formatWan
                  }}(扣除手续费: {{ (amountInfo.withdrawWaitVoucher * 0.94).toFixed(2) | formatWan }})
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="余额" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                <div>待提：{{
                    amountInfo.activeAmount | formatWan
                  }}(扣除手续费: {{ (amountInfo.activeAmount * 0.99).toFixed(2) | formatWan }})
                </div>
                <div>已提：{{
                    amountInfo.withdrawAmount | formatWan
                  }}(扣除手续费: {{ (amountInfo.withdrawAmount * 0.99).toFixed(2) | formatWan }})
                </div>
                <div>待审：{{
                    amountInfo.withdrawWaitAmount | formatWan
                  }}(扣除手续费: {{ (amountInfo.withdrawWaitAmount * 0.99).toFixed(2) | formatWan }})
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="超发" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                <div>余额：{{
                    (+poolInfo.oneOverissuanceAmountTotal || 0) + (+poolInfo.twoOverissuanceAmountTotal || 0) | formatWan
                  }}(扣除手续费: {{
                    (((poolInfo.oneOverissuanceAmountTotal || 0) + (+poolInfo.twoOverissuanceAmountTotal || 0)) * 0.99).toFixed(2) | formatWan
                  }})
                </div>
                <div>消费券：{{
                    (+poolInfo.oneOverissuanceVoucherTotal || 0) + (+poolInfo.twoOverissuanceVoucherTotal || 0) | formatWan
                  }}(扣除手续费: {{
                    (((+poolInfo.oneOverissuanceVoucherTotal || 0) + (+poolInfo.twoOverissuanceVoucherTotal || 0)) * 0.94).toFixed(2) | formatWan
                  }})
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="合伙人" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                <div>待提：{{ amountInfo.partnerActiveAmount | formatWan }}</div>
                <div>已提：{{ amountInfo.partnerWithdrawAmount | formatWan }}</div>
                <div>待审：{{ amountInfo.partnerWithdrawWaitAmount | formatWan }}</div>
              </el-descriptions-item>
              <el-descriptions-item label="清算(二选一)" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                <div>1.余额(含消费券)：{{
                    (+poolInfo.oneLiquidationAmount || 0) + (+poolInfo.twoOverissuanceVoucherTotal || 0) + (+poolInfo.oneLiquidationVoucher || 0) + (+poolInfo.twoLiquidationVoucher || 0) | formatWan
                  }}(扣除手续费: {{
                    (((+poolInfo.oneLiquidationAmount || 0) + (+poolInfo.twoOverissuanceVoucherTotal || 0)) * 0.99 +
                        ((+poolInfo.oneLiquidationVoucher || 0) + (+poolInfo.twoLiquidationVoucher || 0)) * 0.94).toFixed(2) | formatWan
                  }})
                </div>
                <div>2.转换提货券：{{
                    (((+poolInfo.oneLiquidationAmount || 0) + (+poolInfo.twoOverissuanceVoucherTotal || 0) + (+poolInfo.oneLiquidationVoucher || 0) + (+poolInfo.twoLiquidationVoucher || 0)) * 0.35) | formatWan
                  }}
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="公司综合成本" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                <div>{{ amountInfo.comprehensiveCost | formatWan }}
                  <el-link icon="el-icon-edit" size="mini" style="margin-left: 5px" type="primary"
                           @click="editComprehensiveAmount">编辑
                  </el-link>
                </div>
              </el-descriptions-item>

            </el-descriptions>
          </el-descriptions-item>
          <el-descriptions-item label="总计" labelStyle="font-weight: bold;text-align: center"
                                contentStyle="text-align: center">
            <el-descriptions class="margin-top" :column="1" size="small" border>
              <el-descriptions-item label="总收入" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                {{
                  (poolStat.historyCashIncome + ((orderStatData.salesRevenue * 0.35) + orderStatData.cashRevenue - orderStatData.costRevenue) + amountInfo.partnerIncome).toFixed(2) | formatWan
                }}(扣除手续费:
                {{
                  (poolStat.historyCashIncome * 0.994 + ((orderStatData.salesRevenue * 0.35) + orderStatData.cashRevenue - orderStatData.costRevenue) + amountInfo.partnerIncome).toFixed(2) | formatWan
                }})
              </el-descriptions-item>
              <el-descriptions-item label="总清算余额支出" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                {{ incomeTotalOutAmount | formatWan }}
              </el-descriptions-item>
              <el-descriptions-item label="总清算提货券支出" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                {{ incomeTotalOutVoucher | formatWan }}
              </el-descriptions-item>
              <el-descriptions-item label="清算余额结余" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                {{ incomeTotalAmount  | formatWan }}
              </el-descriptions-item>
              <el-descriptions-item label="清算提货券结余" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                {{ incomeTotal | formatWan }}
              </el-descriptions-item>
              <el-descriptions-item label="当前盈余" labelStyle="font-weight: bold;text-align: center"
                                    contentStyle="text-align: center">
                {{ currentSurplus | formatWan }}
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions direction="vertical" :column="5" border>
          <el-descriptions-item label="订单完成数" labelStyle="font-weight: bold;text-align: center"
                                contentStyle="text-align: center">
            <div>总数：{{ poolInfo.packageCount }}</div>
            <div>今日：{{ +poolInfo.todayWaitInTheOnePool + +poolInfo.todayWaitInTheTwoPool }}</div>
            <div>昨日：{{ +poolInfo.yesterdayInOnePool + +poolInfo.yesterdayInTwoPool }}</div>
            <div style="height: 1rem"></div>
            <div>供应链订单数：{{ orderStatData.totalOrderCount }}</div>
            <div>供应链订今日单数：{{ todayOrderCount }}</div>
            <div>供应链订昨日单数：{{ yesterdayOrderCount }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="用户概况" labelStyle="font-weight: bold;text-align: center"
                                contentStyle="text-align: center">
            <div>今日新增用户数：{{ poolInfo.todayNewUser || 0 }}
            </div>
            <div>昨日新增用户数：{{ poolInfo.yesterdayNewUser || 0 }}
            </div>
          </el-descriptions-item>

          <el-descriptions-item label="顶部待匹配订单时间" labelStyle="font-weight: bold;text-align: center"
                                contentStyle="text-align: center">
            <div>一号池: {{ poolInfo.oneTopTime || '暂无数据' }} (剩余人数：{{ onePeopleCount }})</div>
            <div>超发金额: {{ poolInfo.oneOverissuanceAmount | formatWan }}</div>
            <div>超发消费券: {{ poolInfo.oneOverissuanceVoucherTotal | formatWan }}({{
                (poolInfo.oneOverissuanceVoucherTotal || 0) * 0.94 | formatWan
              }})
            </div>
            <div style="height: 1rem"></div>
            <div>二号池: {{ poolInfo.twoTopTime || '暂无数据' }} (剩余人数：{{ twoPeopleCount }})</div>
            <div>超发金额: {{ poolInfo.twoOverissuanceAmount | formatWan }}</div>
            <div>超发消费券: {{ poolInfo.twoOverissuanceVoucher | formatWan }}({{
                (poolInfo.twoOverissuanceVoucher || 0) * 0.94 | formatWan
              }})
            </div>
          </el-descriptions-item>


        </el-descriptions>

      </el-card>
      <div style="display: flex">
        <el-card class="box-card" style="width: 33%">
          <div slot="header" class="clearfix">
            <span style="font-size: 16px;font-weight: bold;">待匹配池信息</span>
          </div>
          <el-table border :data="poolInfoList">
            <el-table-column label="当前待入池总数" align="center" prop="todayWaitInThePool">
            </el-table-column>
            <el-table-column label="昨日待入池总数" align="center" prop="yesterdayWaitInThePool">
            </el-table-column>
          </el-table>
          <el-table border :data="waitInList">
            <el-table-column label="日期" align="center" prop="createTime">
            </el-table-column>
            <el-table-column label="待入池总数" align="center" prop="unsuccessfulCount">
            </el-table-column>
          </el-table>
          <div style="display: flex;justify-content: center;margin-top: 10px">
            <el-pagination
                small
                @size-change="waitInHandleSizeChange"
                @current-change="waitInHandleCurrentChange"
                :current-page="waitInToParams.current"
                :page-sizes="[3,10, 20, 50, 100]"
                :page-size="waitInToParams.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="waitInToTotal">
            </el-pagination>
          </div>
        </el-card>
        <el-card class="box-card" style="width: 33%">
          <div slot="header" class="clearfix">
            <span style="font-size: 16px;font-weight: bold;">一号池信息</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="openTokenEdit(1)">修改一号入池限额
            </el-button>
          </div>
          <el-table border :data="poolInfoList">
            <el-table-column label="今日匹配数量" align="center" prop="todayWaitInTheOnePool">
            </el-table-column>
            <el-table-column label="昨日匹配数量" align="center" prop="yesterdayInOnePool">
            </el-table-column>
            <el-table-column label="匹配池入池限额数量" align="center" prop="oneTodayMaxToken">
            </el-table-column>
            <el-table-column label="匹配池剩余待匹配数量" align="center" prop="oneWaitCount">
            </el-table-column>
          </el-table>
          <el-table border :data="onePoolList">
            <el-table-column label="日期" align="center" prop="createTime">
            </el-table-column>
            <el-table-column label="未匹配数" align="center" prop="unsuccessfulCount">
            </el-table-column>
            <el-table-column label="已匹配数" align="center" prop="successfulCount">
            </el-table-column>
          </el-table>
          <div style="display: flex;justify-content: center;margin-top: 10px">
            <el-pagination
                small
                @size-change="oneHandleSizeChange"
                @current-change="oneHandleCurrentChange"
                :current-page="onePoolParams.current"
                :page-sizes="[3,10, 20, 50, 100]"
                :page-size="onePoolParams.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="onePoolTotal">
            </el-pagination>
          </div>
        </el-card>
        <el-card class="box-card" style="width: 33%">
          <div slot="header" class="clearfix">
            <div slot="header" class="clearfix">
              <span style="font-size: 16px;font-weight: bold;">二号池信息</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="openTokenEdit(2)">修改二号入池限额
              </el-button>
            </div>
          </div>
          <el-table border :data="poolInfoList">
            <el-table-column label="今日匹配数量" align="center" prop="todayWaitInTheTwoPool">
            </el-table-column>
            <el-table-column label="昨日匹配数量" align="center" prop="yesterdayInTwoPool">
            </el-table-column>
            <el-table-column label="匹配池入池限额数量" align="center" prop="twoTodayMaxToken">
            </el-table-column>
            <el-table-column label="匹配池剩余待匹配数量" align="center" prop="twoWaitCount">
            </el-table-column>
          </el-table>
          <el-table border :data="twoPoolList">
            <el-table-column label="日期" align="center" prop="createTime">
            </el-table-column>
            <el-table-column label="未匹配数" align="center" prop="unsuccessfulCount">
            </el-table-column>
            <el-table-column label="已匹配数" align="center" prop="successfulCount">
            </el-table-column>
          </el-table>
          <div style="display: flex;justify-content: center;margin-top: 10px">
            <el-pagination
                small
                @size-change="twoInHandleSizeChange"
                @current-change="twoHandleCurrentChange"
                :current-page="twoPoolParams.current"
                :page-sizes="[3,10, 20, 50, 100]"
                :page-size="twoPoolParams.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="twoPoolTotal">
            </el-pagination>
          </div>
        </el-card>
      </div>

    </div>

    <el-dialog title="算力池配置" :visible.sync="packageConfigEditDialog" width="800px">
      <el-form ref="packageConfigEditForm" :model="packageConfigEdit" label-width="300px" size="small"
               :rules="packageConfigRules">
        <el-form-item label="一号池默认Token(个)" prop="queueOneMaxToken">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.queueOneMaxToken"></el-input-number>
        </el-form-item>
        <el-form-item label="二号池默认Token(个)" prop="queueTwoMaxToken">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.queueTwoMaxToken"></el-input-number>
        </el-form-item>
        <el-form-item label="一号池匹配数量(个)" prop="queueOneRatio">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.queueOneRatio"></el-input-number>
        </el-form-item>
        <el-form-item label="二号池匹配数量(个)" prop="queueTwoRatio">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.queueTwoRatio"></el-input-number>
        </el-form-item>
        <el-form-item label="匹配中增加虚人数区间(人数)" prop="unsuccessfulMinAddVirtual">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.unsuccessfulMinAddVirtual"></el-input-number>
          ~
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.unsuccessfulMaxAddVirtual"></el-input-number>
          人
        </el-form-item>
        <el-form-item label="匹配成功增加虚人数区间(人数)" prop="successfulMinAddVirtual">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.successfulMinAddVirtual"></el-input-number>
          ~
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.successfulMaxAddVirtual"></el-input-number>
          人
        </el-form-item>
        <el-form-item label="每日限购数量" prop="dailyOrderLimit">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.dailyOrderLimit"></el-input-number>
        </el-form-item>
        <el-form-item label="最大获取价格次数" prop="maxGetPriceCount">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.maxGetPriceCount"></el-input-number>
        </el-form-item>
        <el-form-item label="最大支付次数" prop="maxPayCount">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.maxPayCount"></el-input-number>
        </el-form-item>
        <el-form-item label="获取支付次数未满增加金额区间(元)" prop="minAddMoneyPayNotMax">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.minAddMoneyPayNotMax"></el-input-number>
          ~
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.maxAddMoneyPayNotMax"></el-input-number>
          元
        </el-form-item>
        <el-form-item label="获取支付次数已满增加金额区间(元)" prop="minAddMoneyPayMax">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.minAddMoneyPayMax"></el-input-number>
          ~
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           v-model="packageConfigEdit.maxAddMoneyPayMax"></el-input-number>
          元
        </el-form-item>
        <el-form-item label="最大成功奖励发放次数" prop="maxRewardSendCount">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.maxRewardSendCount"></el-input-number>
        </el-form-item>
        <el-form-item label="最大未成功奖励发放次数" prop="maxRewardSendUnsuccessfulCount">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                           :precision="0" v-model="packageConfigEdit.maxRewardSendUnsuccessfulCount"></el-input-number>
        </el-form-item>
        <el-form-item label="支付宝付款主体" prop="aliPayConfig">
          <el-input size="small" style="width: 150px" :min="0" controls-position="right"
                    :precision="0" v-model="packageConfigEdit.aliPayConfig"></el-input>
        </el-form-item>
        <el-form-item label="退款截止时间" prop="endRefundTime">
          <el-input size="small" style="width: 150px" :min="0" controls-position="right"
                    :precision="0" v-model="packageConfigEdit.endRefundTime"></el-input>
        </el-form-item>
        <el-form-item label="最大匹配 A池数量" prop="poolNumOneMaxCount">
          <el-input-number size="small" style="width: 150px" :min="0" controls-position="right"
                    :precision="0" v-model="packageConfigEdit.poolNumOneMaxCount"></el-input-number>
        </el-form-item>
        <el-form-item label="最大匹配 A池比例" prop="poolNumOneMaxRatio">
          <el-input-number size="small" style="width: 150px" :min="0.01" controls-position="right" :step="0.1"
                    :precision="2" v-model="packageConfigEdit.poolNumOneMaxRatio"></el-input-number>
        </el-form-item>
        <div style="text-align: right">
          <el-button @click="packageConfigEditDialog = false">取消</el-button>
          <el-button type="primary" @click="editPackageConfig">保存</el-button>
        </div>
      </el-form>

    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="top10Visible"
               title="合伙人账户收益排行榜"
               width="40%">
      <el-table :data="topList" max-height="720">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="会员ID" prop="userId"></el-table-column>
        <el-table-column label="会员名称" prop="nickName"></el-table-column>
        <el-table-column label="会员手机号" prop="tel"></el-table-column>
        <el-table-column label="等级" prop="levelName"></el-table-column>
        <el-table-column label="公司名称" prop="companyName"></el-table-column>
        <el-table-column label="达人数" prop="digitalCount"></el-table-column>
        <el-table-column label="收益总额" prop="totalRewardAmount">
          <template slot-scope="scope">
            {{ scope.row.totalRewardAmount | formatWan }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="comprehensiveAmountDialog" title="修改综合收入/成本"
               width="40%">
      <el-form :model="editComprehensiveAmountData" :rules="editComprehensiveAmountRules"
               ref="editComprehensiveAmountRuleForm" label-width="100px">
        <el-form-item label="综合成本" prop="comprehensiveCost">
          <el-input-number v-model="editComprehensiveAmountData.comprehensiveCost" :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="合伙人收入" prop="partnerIncome">
          <el-input-number v-model="editComprehensiveAmountData.partnerIncome" :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button @click="comprehensiveAmountDialog = false">关闭</el-button>
          <el-button type="primary" @click="submitFormEditComprehensiveAmount">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 例如：import uploadFile from '@/components/uploadFile/uploadFile'

import {
  editPoolMaxTokenApi,
  getAmountStatApi,
  getPageByPoolNumApi,
  getPoolInfoApi,
  getPoolPeopleCountApi,
  getPoolStatApi, setComprehensiveAmountApi
} from "@/api/packageSystemConfigApi";
import {getByConfigKey, updateDocumentConfig} from "@/api/basicConfig";
import {formatMoney, formatWan} from "@/utils/formatMoney";
import {getAccountTopList} from "@/api/PartnerAccountApi";
import {getOrderStatApi} from "@/api/orderApi";

export default {
  name: 'packageSystemConfig',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    // patientIn: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  filters: {
    formatWan(amount) {
      return formatWan(amount)
    },
  },
  data() {
    // 这里存放数据
    return {
      top10Visible: false,
      comprehensiveAmountDialog: false,
      topList: [],
      editPackageConfigData: {},
      packageConfigList: [],
      packageConfigEdit: {
        "queueOneMaxToken": 2000,
        "queueTwoMaxToken": 1000,
        "queueOneRatio": 2,
        "queueTwoRatio": 1,
        "unsuccessfulMinAddVirtual": 0,
        "unsuccessfulMaxAddVirtual": 100,
        "successfulMinAddVirtual": 500,
        "successfulMaxAddVirtual": 1000,
        "dailyOrderLimit": 1000,
        "maxPayCount": 2
      },
      packageConfigEditDialog: false,
      packageConfigRules: {
        queueOneMaxToken: [
          {required: true, message: '请输入一号池默认Token(个)', trigger: 'blur'},
          {type: 'number', message: '一号池默认Token(个)必须为数字值', trigger: 'blur'}
        ],
        queueTwoMaxToken: [
          {required: true, message: '请输入二号池默认Token(个)', trigger: 'blur'},
          {type: 'number', message: '二号池默认Token(个)必须为数字值', trigger: 'blur'}
        ],
        queueOneRatio: [
          {required: true, message: '请输入一号池匹配数量(个)', trigger: 'blur'},
          {type: 'number', message: '一号池匹配数量(个)必须为数字值', trigger: 'blur'}
        ],
        queueTwoRatio: [
          {required: true, message: '请输入二号池匹配数量(个)', trigger: 'blur'},
          {type: 'number', message: '二号池匹配数量(个)必须为数字值', trigger: 'blur'}
        ],
        unsuccessfulMinAddVirtual: [
          {required: true, message: '请输入匹配中增加虚人数区间(人数)', trigger: 'blur'},
          {type: 'number', message: '匹配中增加虚人数区间(人数)必须为数字值', trigger: 'blur'}
        ],
        successfulMinAddVirtual: [
          {required: true, message: '请输入匹配成功增加虚人数区间(人数)', trigger: 'blur'},
          {type: 'number', message: '匹配成功增加虚人数区间(人数)必须为数字值', trigger: 'blur'}
        ],
        dailyOrderLimit: [
          {required: true, message: '请输入每日限购数量', trigger: 'blur'},
          {type: 'number', message: '每日限购数量必须为数字值', trigger: 'blur'}
        ],
        maxGetPriceCount: [
          {required: true, message: '请输入最大获取价格次数', trigger: 'blur'},
          {type: 'number', message: '最大获取价格次数必须为数字值', trigger: 'blur'}
        ],
        maxPayCount: [
          {required: true, message: '请输入最大支付次数', trigger: 'blur'},
          {type: 'number', message: '最大支付次数必须为数字值', trigger: 'blur'}
        ],
        minAddMoneyPayNotMax: [
          {required: true, message: '请输入获取支付次数未满增加金额区间(元)', trigger: 'blur'},
          {type: 'number', message: '获取支付次数未满增加金额区间(元)必须为数字值', trigger: 'blur'}
        ],
        minAddMoneyPayMax: [
          {required: true, message: '请输入获取支付次数已满增加金额区间(元)', trigger: 'blur'},
          {type: 'number', message: '获取支付次数已满增加金额区间(元)必须为数字值', trigger: 'blur'}
        ],
        maxRewardSendCount: [
          {required: true, message: '请输入最大成功奖励发放次数', trigger: 'blur'},
          {type: 'number', message: '最大成功奖励发放次数必须为数字值', trigger: 'blur'}
        ],
        maxRewardSendUnsuccessfulCount: [
          {required: true, message: '请输入最大未成功奖励发放次数', trigger: 'blur'},
          {type: 'number', message: '最大未成功奖励发放次数必须为数字值', trigger: 'blur'}
        ],
        aliPayConfig: [
          {required: true, message: '请输入支付宝支付主体', trigger: 'blur'}
        ],
        endRefundTime: [
          {required: true, message: '请输入退款截止时间', trigger: 'blur'}
        ],
        poolNumOneMaxCount: [
          {required: true, message: '请输入最大匹配 A池数量', trigger: 'blur'},
          {type: 'number', message: '请输入最大匹配 A池数量必须为数字值', trigger: 'blur'}
        ],
        poolNumOneMaxRatio: [
          {required: true, message: '请输入最大匹配 A池比例', trigger: 'blur'},
          {type: 'number', message: '最大匹配 A池比例必须为数字值', trigger: 'blur'}
        ]
      },
      poolInfoList: [],
      todayOrderCount: 0,
      yesterdayOrderCount: 0,
      onePeopleCount: 0,
      twoPeopleCount: 0,
      incomeTotal: 0,
      incomeTotalAmount: 0,
      incomeTotalOutAmount: 0,
      incomeTotalOutVoucher: 0,
      poolInfo: {},
      orderStatData: {},
      amountInfo: {},
      poolStat: {},
      waitInList: [],
      waitInToTotal: 0,
      onePoolTotal: 0,
      twoPoolTotal: 0,
      currentSurplus: 0,
      onePoolList: [],
      twoPoolList: [],
      waitInToParams: {
        size: 3,
        current: 1,
        type: 0
      },
      onePoolParams: {
        size: 3,
        current: 1,
        type: 1
      },
      twoPoolParams: {
        size: 3,
        current: 1,
        type: 2
      },
      editComprehensiveAmountData: {
        comprehensiveCost: 0,
        partnerIncome: 0,
      },
      editComprehensiveAmountRules: {
        partnerIncome: [
          {required: true, message: '请输入合伙人收入', trigger: 'blur'},
          {type: 'number', message: '合伙人收入必须为数字值', trigger: 'blur'}
        ],
        comprehensiveCost: [
          {required: true, message: '请输入综合成本', trigger: 'blur'},
          {type: 'number', message: '综合成本必须为数字值', trigger: 'blur'}
        ]
      }

    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 方法集合
  methods: {
    submitFormEditComprehensiveAmount() {
      this.$refs['editComprehensiveAmountRuleForm'].validate(async (valid) => {
        if (valid) {
          await setComprehensiveAmountApi(this.editComprehensiveAmountData)
          this.getPoolStat()
          this.comprehensiveAmountDialog = false
        } else {
          return false;
        }
      });
    },
    editComprehensiveAmount() {
      this.editComprehensiveAmountData = {
        comprehensiveCost: this.amountInfo.comprehensiveCost,
        partnerIncome: this.amountInfo.partnerIncome
      }
      this.comprehensiveAmountDialog = true
    },
    async openTop10() {
      this.top10Visible = true;
      const data = await getAccountTopList();
      this.topList = data.data;
    },
    waitInHandleSizeChange(val) {
      this.waitInToParams.size = val
      this.getWaitInList()
    },
    waitInHandleCurrentChange(val) {
      this.waitInToParams.current = val
      this.getWaitInList()
    },
    oneHandleSizeChange(val) {
      this.onePoolParams.size = val
      this.getOnePoolList()
    },
    oneHandleCurrentChange(val) {
      this.onePoolParams.current = val
      this.getOnePoolList()
    },
    twoInHandleSizeChange(val) {
      this.twoPoolParams.size = val
      this.getTwoPoolList()
    },
    twoHandleCurrentChange(val) {
      this.twoPoolParams.current = val
      this.getTwoPoolList()
    },
    async getPackageConfig() {
      this.packageConfigList = []
      let {data} = await getByConfigKey({configKey: "package_config"});
      this.packageConfigList.push(JSON.parse(data.configValue))
      this.packageConfigEdit = JSON.parse(data.configValue);
      this.editPackageConfigData = data
    },
    async getPoolInfo() {
      this.poolInfoList = []
      let {data} = await getPoolInfoApi();
      this.poolInfoList.push(data)
      let originalData = JSON.parse(JSON.stringify(data));
      this.poolInfo = data

      this.getPoolPeopleCount(1, data.oneTopTime);
      this.getPoolPeopleCount(2, data.twoTopTime);
      return originalData;
    },
    async getAmountStat() {
      let {data} = await getAmountStatApi();
      let originalData = JSON.parse(JSON.stringify(data));
      this.amountInfo = data
      this.editComprehensiveAmountData = {
        comprehensiveCost: data.comprehensiveCost,
        partnerIncome: data.partnerIncome,
      }
      // 循环this.amountInfo每一个字段
      /*      for (let key in this.amountInfo) {
              this.amountInfo[key] = formatWan(this.amountInfo[key]);
            }*/
      return originalData;
    },
    async getOrderStatToday() {
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };
      const today = new Date();
      const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
      const todayEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);

      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      const yesterdayStart = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0);
      const yesterdayEnd = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59);

      let todayRes = await getOrderStatApi({
        startTime: formatDate(todayStart),
        endTime: formatDate(todayEnd)
      })
      let yesterdayRes = await getOrderStatApi({
        startTime: formatDate(yesterdayStart),
        endTime: formatDate(yesterdayEnd)
      })
      this.yesterdayOrderCount = yesterdayRes.data.totalOrderCount
      this.todayOrderCount = todayRes.data.totalOrderCount
    },
    async getPoolPeopleCount(packageNum, time) {
      let day = time.substring(0, 10);
      let {data} = await getPoolPeopleCountApi({day: day, packageNum: packageNum});
      if (packageNum === 1) {
        this.onePeopleCount = data;
      } else {
        this.twoPeopleCount = data;
      }
    },
    async getPoolStat() {
      let {data} = await getPoolStatApi();
      this.poolStat = data
      let originalData = JSON.parse(JSON.stringify(data));
      // poolStatus里的所有字段都用formatWan方法转换
      /*      this.poolStat.todayCashIncome = formatWan(data.todayCashIncome);
            this.poolStat.todayBalanceIncome = formatWan(data.todayBalanceIncome);
            this.poolStat.historyCashIncome = formatWan(data.historyCashIncome);
            this.poolStat.historyBalanceIncome = formatWan(data.historyBalanceIncome);*/

      let amountStat = await this.getAmountStat();
      let poolInfo = await this.getPoolInfo();

      const historyCashIncome = Number(originalData.historyCashIncome) || 0;
      const historyBalanceIncome = Number(originalData.historyBalanceIncome) || 0;

      let res = await getOrderStatApi();
      let orderStatData = res.data
      this.orderStatData = orderStatData;

      let spending = (amountStat.withdrawAmount + amountStat.withdrawWaitAmount + amountStat.activeAmount) * 0.99 +
          (amountStat.withdrawVoucher + amountStat.withdrawWaitVoucher + amountStat.activeVoucher) * 0.94 +
          amountStat.activePickUpVoucher * 0.35 + orderStatData.costRevenue +
          amountStat.partnerWithdrawWaitAmount + amountStat.partnerActiveAmount + amountStat.partnerWithdrawAmount;
      this.incomeTotalOutAmount = (
          spending +
          (((+poolInfo.oneLiquidationAmount || 0) + (+poolInfo.twoOverissuanceVoucherTotal || 0)) * 0.99 +
              ((+poolInfo.oneLiquidationVoucher || 0) + (+poolInfo.twoLiquidationVoucher || 0)) * 0.94)).toFixed(4);

      this.incomeTotalOutVoucher = (
          spending +
          ((poolInfo.oneLiquidationAmount || 0) + (poolInfo.twoOverissuanceVoucherTotal || 0) +
              (poolInfo.oneLiquidationVoucher || 0) + (poolInfo.twoLiquidationVoucher || 0)) * 0.35).toFixed(4);

      this.incomeTotal = (historyCashIncome * 0.994 + ((orderStatData.salesRevenue * 0.35) + orderStatData.cashRevenue - orderStatData.costRevenue)
          + amountStat.partnerIncome -
          this.incomeTotalOutVoucher - amountStat.comprehensiveCost).toFixed(4);

      this.incomeTotalAmount = (historyCashIncome * 0.994 + ((orderStatData.salesRevenue * 0.35) + orderStatData.cashRevenue - orderStatData.costRevenue)
          + amountStat.partnerIncome -
          this.incomeTotalOutAmount - amountStat.comprehensiveCost).toFixed(4);
      this.currentSurplus = (historyCashIncome * 0.994 + ((orderStatData.salesRevenue * 0.35) + orderStatData.cashRevenue - orderStatData.costRevenue)
          + amountStat.partnerIncome - spending - amountStat.comprehensiveCost).toFixed(4);
    },
    async getWaitInList() {
      let {data} = await getPageByPoolNumApi(this.waitInToParams);
      this.waitInToTotal = data.total
      this.waitInList = data.rows
    },
    async getOnePoolList() {
      let {data} = await getPageByPoolNumApi(this.onePoolParams);
      this.onePoolTotal = data.total
      this.onePoolList = data.rows
    },
    async getTwoPoolList() {
      let {data} = await getPageByPoolNumApi(this.twoPoolParams);
      this.twoPoolTotal = data.total
      this.twoPoolList = data.rows
    },

    openTokenEdit(pool) {
      this.$prompt('请输入调整数量', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*[1-9][0-9]*$/,
        inputErrorMessage: '数量错误'
      }).then(({value}) => {
        this.$alert('你确认修改吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          callback: async (action) => {
            await editPoolMaxTokenApi({poolNum: pool, maxToken: value})
            await this.getPoolInfo()
          }
        });
      });
    },
    editPackageConfig() {
      this.$refs.packageConfigEditForm.validate((valid) => {
        if (valid) {
          this.$confirm('你确认修改算力配置吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(async () => {
            this.editPackageConfigData.configValue = JSON.stringify(this.packageConfigEdit)
            await updateDocumentConfig(this.editPackageConfigData)
            await this.getPackageConfig()
            this.packageConfigEditDialog = false
          }).catch(() => {

          });
        } else {
          return false;
        }
      });
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  async mounted() {
    // await this.getPoolInfo()
    this.getOrderStatToday()
    this.getPackageConfig()
    this.getWaitInList()
    this.getOnePoolList()
    this.getTwoPoolList()
    await this.getPoolStat()
  },
  beforeCreate() {
  }, // 生命周期 - 创建之前
  beforeMount() {
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
  }, // 生命周期 - 更新之前
  updated() {
  }, // 生命周期 - 更新之后
  beforeDestroy() {
  }, // 生命周期 - 销毁之前
  destroyed() {
  }, // 生命周期 - 销毁完成
  activated() {
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.app-container {
  padding: 20px;
  margin-bottom: 40px;
}

.filter-container {
  padding: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
</style>